import Vue, { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'

import { Legend } from '@src/components/legend/legend'

@Component({
  computed: {
    checkupFilters () {
      return this.$store.state.checkups.checkupFilters
    }
  }
})
export class CheckupsFilter extends Vue {

  private static COLOR_MAPPING = { completed: 'blue', planned: 'red', in_progress: 'grey' }

  private checkupFilters: string[]

  constructor () {
    super()
  }

  filterCheckupsByStatus (value) {
    let checkupFilters = [...this.checkupFilters]
    const index = checkupFilters.indexOf(value)
    if (index >= 0) {
      checkupFilters.splice(index, 1)
    } else {
      checkupFilters.push(value)
    }

    this.$store.dispatch('filterCheckups', checkupFilters)
  }

  render (h: CreateElement) {
    return <div id='checkups-desktop-filter-wrapper'>
      <Legend select={this.filterCheckupsByStatus}
                   items={[
                     {
                       type: 'completed',
                       label: this.$t('PAGE.MEMBERS.CHECKUPS.STATUS.COMPLETED'),
                       color: CheckupsFilter.COLOR_MAPPING.completed,
                       disabled: this.checkupFilters.includes('completed')
                     },
                     {
                       type: 'planned',
                       label: this.$t('PAGE.MEMBERS.CHECKUPS.STATUS.PLANNED'),
                       color: CheckupsFilter.COLOR_MAPPING.planned,
                       disabled: this.checkupFilters.includes('planned')
                     },
                     {
                       type: 'in_progress',
                       label: this.$t('PAGE.MEMBERS.CHECKUPS.STATUS.IN_PROGRESS'),
                       color: CheckupsFilter.COLOR_MAPPING.in_progress,
                       disabled: this.checkupFilters.includes('in_progress')
                     }
                   ]} />
    </div>
  }
}
